import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { setShowingDialogState } from 'src/redux/slices/showDialog.slice';
import { RootState } from 'src/redux/store';
import { fpost } from '../../../lib/fetch';
import { configWaterLevel, configVelocity, dataVelocity, dataWaterLevel } from '../dataChart/DoubleChart';
import '../../map-dialog/components/WaterLevel.css';
import { Button } from '../../../lib/components/Button.component';
import { ResponseListDocuments } from '../../dashboard/dto/response';
import { DeviceRecord } from '../../dashboard/dto/device/deviceRecord';
import { toasting } from '../../../lib/components/Toast.component';
// @ts-ignore
import DatePicker from 'react-datepicker';
// @ts-ignore
import { CSVLink } from 'react-csv';
import { AiOutlineReload } from 'react-icons/ai';
import { twMerge } from 'tailwind-merge';
import { option } from "../../dashboard/interfaces/option";

export function DialogWaterLevel() {
  const showDialog = useSelector((state: RootState) => state.showDialogReducer.showDialogWaterLevel);
  const dataDialog = useSelector((state: RootState) => state.showDialogReducer.position);

  const [active, setActive] = useState(1);
  const [disabledSwitchButton, setDisabledSwitchButton] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [isReloading, setIsReloading] = useState(false);
  const csvLinkRef = useRef<any>(null);
  const [isRangeInvalid, setIsRangeInvalid] = useState(false);
  const [isTimeSelectable, setIsTimeSelectable] = useState(false);
  const [isMonthSelectable, setIsMonthSelectable] = useState(false);
  const [isYearSelectable, setIsYearSelectable] = useState(false);
  const [dateFormat, setDateformat] = useState('yyyy-MM-dd');
  const [minVelocitySetting, setMinVelocitySetting] = useState<number | null>(null);
  const [maxVelocitySetting, setMaxVelocitySetting] = useState<number | null>(null);
  const [minWaterRateSetting, setMinWaterRateSetting] = useState<number | null>(null);
  const [maxWaterRateSetting, setMaxWaterRateSetting] = useState<number | null>(null);
  const [minWaterLevelSetting, setMinWaterLevelSetting] = useState<number | null>(null);
  const [maxWaterLevelSetting, setMaxWaterLevelSetting] = useState<number | null>(null);

  // Show placeholder when no device is selected - moved to conditional rendering
  const showPlaceholder = !dataDialog || !dataDialog.deviceId;

  const handleMinMax = async (e: any, inputCase: string) => {

    const newValue = e.target.value;
    switch (inputCase) {
      case 'minVelocitySetting':
        setMinVelocitySetting(newValue);
        break;
      case 'maxVelocitySetting':
        setMaxVelocitySetting(newValue);
        break;
      case 'minWaterRateSetting':
        setMinWaterRateSetting(newValue);
        break;
      case 'maxWaterRateSetting':
        setMaxWaterRateSetting(newValue);
        break;
      case 'minWaterLevelSetting':
        setMinWaterLevelSetting(newValue);
        break;
      case 'maxWaterLevelSetting':
        setMaxWaterLevelSetting(newValue);
        break;
    }
    // Gọi hàm debounce
    // await debouncedChange(active);
  };

  const option: option = {
    minVelocitySetting: minVelocitySetting,
    maxVelocitySetting: maxVelocitySetting,
    minWaterRateSetting: minWaterRateSetting,
    maxWaterRateSetting: maxWaterRateSetting,
    minWaterLevelSetting: minWaterLevelSetting,
    maxWaterLevelSetting: maxWaterLevelSetting,
  }

  const getHourInDay = (hour: number) => {
    const newHour = (hour + 9) % 24;
    return newHour >= 0 ? newHour : newHour + 24;
  }

  const getFirstDayOfWeek = (date: Date) => {
    return date.getTime() - ((date.getDay() === 0 ? 6 : date.getDay() - 1)) * 24 * 60 * 60 * 1000
  }

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
  };

  const getTimeWithZero = (time: number) => {
    return time < 10 ? '0' + time : time;
  }

  const setChartLabelString = (action: number) => {
    let label = '';

    let year = new Date().getFullYear();
    let month: number | string = new Date().getMonth() + 1;
    let hour = new Date().getHours();
    let day = new Date().getDate();
    let dow = new Date().getDay() - 1;
    let startDayOfWeekTimestamp = getFirstDayOfWeek(new Date());
    if (startDate) {
      year = startDate.getFullYear();
      month = startDate.getMonth() + 1;
      hour = startDate.getHours();
      day = startDate.getDate();
      dow = startDate.getDay() - 1;
      startDayOfWeekTimestamp = getFirstDayOfWeek(startDate);
    }
    // convert to two digits
    month = month < 10 ? '0' + month.toString() : month;

    const endDayOfWeekTimestamp = startDayOfWeekTimestamp + 6 * 24 * 60 * 60 * 1000;
    const endDayOfWeek = new Date(endDayOfWeekTimestamp);
    const startDayOfWeek = new Date(startDayOfWeekTimestamp);
    const startDayOfWeekFull = `${startDayOfWeek.getFullYear()}/${getTimeWithZero(startDayOfWeek.getMonth() + 1)}/${getTimeWithZero(startDayOfWeek.getDate())}`
    const endDayOfWeekFull = `${endDayOfWeek.getFullYear()}/${getTimeWithZero(endDayOfWeek.getMonth() + 1)}/${getTimeWithZero(endDayOfWeek.getDate())}週`
    switch (action) {
      case 1:
        label = `${year}年`;
        break;
      case 2:
        label = `${year}/${month}月`;
        break;
      case 3:
        label = `
         ${startDayOfWeekFull} - ${endDayOfWeekFull}
        `;
        break;
      case 4:
        label = `${year}/${month}/${day}日`;
        break;
      case 5:
        label = `${year}/${month}/${day} ${hour}:00時`;
        break;
    }

    configWaterLevel.options.scales.xAxes[0].scaleLabel.labelString = label;
    configVelocity.options.scales.xAxes[0].scaleLabel.labelString = label;
  };

  const getAdjustedValue = (min: number, max: number) => {
    const range = max - min;
    const scalingFactor = 0.4;

    const adjustedMin = min - range * scalingFactor;
    const adjustedMax = max + range * scalingFactor;

    return [
      adjustedMin,
      adjustedMax,
    ];
  }

  const isSameDay = (startDay: Date, endDay: Date) => {
    return (
      startDay.getDate() === endDay.getDate() &&
      startDay.getMonth() === endDay.getMonth() &&
      startDay.getFullYear() === endDay.getFullYear()
    );
  };

  const isSameMonth = (startDay: Date, endDay: Date) => {
    return (
      startDay.getMonth() === endDay.getMonth() &&
      startDay.getFullYear() === endDay.getFullYear()
    );
  };

  const isSameYear = (startDay: Date, endDay: Date) => {
    return startDay.getFullYear() === endDay.getFullYear();
  };

  const isWithinSameWeek = (startDay: Date, endDay: Date) => {
    // Create a copy of startDay for calculations
    const startOfWeek = new Date(startDay);


    // Adjust startOfWeek to the first day of the week (Monday)
    const dayOfWeek = startDay.getDay(); // Get the day of the week (Sunday is 0, Monday is 1, ...)

    // Adjust to Monday (start of the week)
    const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
    startOfWeek.setDate(startDay.getDate() + diffToMonday); // Set startOfWeek to Monday

    // Set endOfWeek to Sunday using setDate
    const endOfWeek = new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate());
    endOfWeek.setDate(startOfWeek.getDate() + 6); // Sunday is 6 days after Monday

    // Check if endDay is within the range from startOfWeek to endOfWeek
    return endDay >= startOfWeek && endDay <= endOfWeek;
  };

  const isSameHour = (startDay: Date, endDay: Date) => {
    return (
      startDay.getFullYear() === endDay.getFullYear() &&
      startDay.getMonth() === endDay.getMonth() &&
      startDay.getDate() === endDay.getDate() &&
      startDay.getHours() === endDay.getHours()
    );
  }


  const resetGraphData = (quantity: number) => {
    dataWaterLevel.datasets[0].data = Array.from({ length: quantity }, () => null);
    dataVelocity.datasets[0].data = Array.from({ length: quantity }, () => null);
  }

  const getYear = async (startDate: Date | null) => {
    setIsYearSelectable(true);
    setIsTimeSelectable(false)
    setIsMonthSelectable(false)
    setDateformat('yyyy')
    // validate
    const deviceId = dataDialog?.deviceId;
    if (!deviceId) return;

    // set label
    const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    dataWaterLevel.labels = labels;
    dataVelocity.labels = labels;

    // set start, end date
    const now = new Date();
    const start = startDate ?
      new Date(startDate.getFullYear(), 0, 1) :
      new Date(now.getFullYear(), 0, 1);
    const end = new Date(start.getFullYear(), 11, 31);

    if (!isSameYear(start, end)) {
      resetGraphData(12)
      return
    }

    setDisabledSwitchButton(true);

    // get record
    const query = {
      query: {
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
          ':timeStart': { S: start.getTime().toString() },
          ':timeEnd': { S: end.getTime().toString() },
        },
        KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
        TableName: 'DEVICE_RECORD_YEAR',
        ScanIndexForward: false,
      },
    };
    const data = await fpost<any>('api/device/record/query', {
      body: query,
    });

    const items = data[1].Items.reverse();
    resetGraphData(12)

    let maxWaterLevel = 100;
    let maxVelocity = 10;
    let minWaterLevel = 0;
    let minVelocity = 0;
    for (const item of items) {
      const month = new Date(parseInt(item.CREATE_AT.S)).getMonth();
      if (item.WATER_LEVEL) {
        const waterLevel = item.WATER_LEVEL.S;
        dataWaterLevel.datasets[0].data[month] = waterLevel;

        maxWaterLevel = Math.max(maxWaterLevel, waterLevel);
        minWaterLevel = Math.min(waterLevel, minWaterLevel);
      }

      if (item.VELOCITY) {
        const velocity = item.VELOCITY.S;
        dataVelocity.datasets[0].data[month] = velocity;

        maxVelocity = Math.max(maxVelocity, velocity);
        minVelocity = Math.min(minVelocity, velocity);
      }
    }

    const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
    const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

    if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterLevelSetting);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterLevelSetting);
    } else {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinWaterLevel);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxWaterLevel);
    }

    if (option.minVelocitySetting && option.maxVelocitySetting) {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(option.minVelocitySetting);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxVelocitySetting);
    } else {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinVelocity);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxVelocity);
    }

    setDisabledSwitchButton(false);
  };

  const getMonth = async (startDate: Date | null) => {
    console.log("get month");
    setIsYearSelectable(false);
    setIsTimeSelectable(false)
    setIsMonthSelectable(true)
    setDateformat('yyyy-MM')

    // validate
    const deviceId = dataDialog?.deviceId;
    if (!deviceId) return;

    // set start end date
    const now = new Date();
    const startDay = startDate ? new Date(startDate.getFullYear(), startDate.getMonth(), 1) : new Date(now.getFullYear(), now.getMonth(), 1);
    const endDay = new Date(startDay.getFullYear(), startDay.getMonth() + 1, 0);
    endDay.setHours(23, 59, 59)

    // set graph label
    const daysInMonth = endDay.getDate();
    const labels = Array.from({ length: daysInMonth }, (_, index) => (index + 1).toString());
    dataWaterLevel.labels = labels;
    dataVelocity.labels = labels;

    if (!isSameMonth(startDay, endDay)) {
      resetGraphData(daysInMonth);
      return
    }

    setDisabledSwitchButton(true);

    const query = {
      query: {
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
          ':timeStart': { S: startDay.getTime().toString() },
          ':timeEnd': { S: endDay.getTime().toString() },
        },
        KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
        TableName: 'DEVICE_RECORD_MONTH',
        ScanIndexForward: false,
      },
    };
    const data = await fpost<any>('api/device/record/query', {
      body: query,
    });
    const items = data[1].Items.reverse();

    resetGraphData(daysInMonth);

    let maxWaterLevel = 100;
    let maxVelocity = 10;
    let minWaterLevel = 0;
    let minVelocity = 0;

    for (const item of items) {
      const dom = new Date(parseInt(item.CREATE_AT.S)).getDate();

      if (item.WATER_LEVEL) {
        const waterLevel = item.WATER_LEVEL.S;
        dataWaterLevel.datasets[0].data[dom - 1] = waterLevel;

        maxWaterLevel = Math.max(maxWaterLevel, waterLevel);
        minWaterLevel = Math.min(minWaterLevel, waterLevel);
      }

      if (item.VELOCITY) {
        const velocity = item.VELOCITY.S;
        dataVelocity.datasets[0].data[dom - 1] = velocity;

        maxVelocity = Math.max(maxVelocity, velocity);
        minVelocity = Math.min(minVelocity, velocity);
      }
    }

    const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
    const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);



    if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterLevelSetting);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterLevelSetting);
    } else {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinWaterLevel);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxWaterLevel);
    }

    if (option.minVelocitySetting && option.maxVelocitySetting) {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(option.minVelocitySetting);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxVelocitySetting);
    } else {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinVelocity);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxVelocity);
    }

    setDisabledSwitchButton(false);
  };

  const getWeek = async (startDate: Date | null) => {
    setIsYearSelectable(false);
    setIsTimeSelectable(false)
    setIsMonthSelectable(false)
    setDateformat('yyyy-MM-dd')

    // validate
    if (isRangeInvalid) return
    const deviceId = dataDialog?.deviceId;
    if (!deviceId) return;

    // set graph label
    const labels = ['MON', 'TUE', 'WED', 'THUR', 'FRI', 'SAT', 'SUN'];
    dataWaterLevel.labels = labels;
    dataVelocity.labels = labels;

    // set start, end date
    const startDay = startDate ? new Date(startDate.getTime()) : new Date();
    startDay.setHours(0, 0, 0, 0);

    setDisabledSwitchButton(true);

    const firstDayOfWeek = getFirstDayOfWeek(startDay);
    const lastDayOfWeek = new Date(firstDayOfWeek + 6 * 24 * 60 * 60 * 1000);
    lastDayOfWeek.setHours(23, 59, 59);

    // get records
    const query = {
      query: {
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
          ':timeStart': { S: firstDayOfWeek.toString() },
          ':timeEnd': { S: lastDayOfWeek.getTime().toString() },
        },
        KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
        TableName: 'DEVICE_RECORD_MONTH',
        ScanIndexForward: false,
      },
    };

    const data = await fpost<any>('api/device/record/query', {
      body: query,
    });
    const items = data[1].Items.reverse();

    resetGraphData(7);

    let maxWaterLevel = 100;
    let maxVelocity = 10;
    let minWaterLevel = 0;
    let minVelocity = 0;

    for (const item of items) {
      const dow = new Date(parseInt(item.CREATE_AT.S)).getDay() == 0 ? 6 : new Date(parseInt(item.CREATE_AT.S)).getDay() - 1;

      if (item.WATER_LEVEL) {
        const waterLevel = item.WATER_LEVEL.S;
        dataWaterLevel.datasets[0].data[dow] = waterLevel;

        maxWaterLevel = Math.max(maxWaterLevel, waterLevel);
        minWaterLevel = Math.min(waterLevel, minWaterLevel);
      }

      if (item.VELOCITY) {
        const velocity = item.VELOCITY.S;
        dataVelocity.datasets[0].data[dow] = velocity;

        maxVelocity = Math.max(maxVelocity, velocity);
        minVelocity = Math.min(minVelocity, velocity);
      }
    }

    const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
    const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

    if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterLevelSetting);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterLevelSetting);
    } else {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinWaterLevel);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxWaterLevel);
    }

    if (option.minVelocitySetting && option.maxVelocitySetting) {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(option.minVelocitySetting);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxVelocitySetting);
    } else {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinVelocity);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxVelocity);
    }

    setDisabledSwitchButton(false);
  };

  const getDay = async (startDate: Date | null) => {
    setIsYearSelectable(false);
    setIsTimeSelectable(false)
    setIsMonthSelectable(false)
    setDateformat('yyyy-MM-dd')

    // validate
    const deviceId = dataDialog?.deviceId;
    if (!deviceId) return;

    // label
    const labels = Array.from({ length: 24 }, (_, index) => ((index)).toString());
    dataWaterLevel.labels = labels;
    dataVelocity.labels = labels;

    // set start, end day
    const startDay = startDate ? new Date(startDate?.getTime()) : new Date();
    const endDay = new Date(startDay.getTime());
    startDay.setHours(0, 0, 0, 0);
    endDay.setHours(23, 59, 59);

    if (!isSameDay(startDay, endDay)) {
      resetGraphData(24);
      return;
    }

    setDisabledSwitchButton(true);

    // get records
    const query = {
      query: {
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
          ':timeStart': { S: startDay.getTime().toString() },
          ':timeEnd': { S: endDay.getTime().toString() },
        },
        KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
        TableName: 'DEVICE_RECORD_DAY',
        ScanIndexForward: false,
      },
    };
    const data = await fpost<any>('api/device/record/query', {
      body: query,
    });

    const items = data[1].Items.reverse();
    resetGraphData(24);
    let maxWaterLevel = 100;
    let maxVelocity = 10;
    let minWaterLevel = 0;
    let minVelocity = 0;
    for (const item of items) {
      const hour = new Date(parseInt(item.CREATE_AT.S)).getUTCHours();
      // if (new Date(parseInt(item.CREATE_AT.S)).getUTCDay() !== new Date().getUTCDay()) continue;
      const idx = getHourInDay(hour); // 1 for index, 1 for hours
      if (item.WATER_LEVEL) {
        const waterLevel = item.WATER_LEVEL.S;
        dataWaterLevel.datasets[0].data[idx] = waterLevel;

        maxWaterLevel = Math.max(maxWaterLevel, waterLevel);
        minWaterLevel = Math.min(waterLevel, minWaterLevel);
      }

      if (item.VELOCITY) {
        const velocity = item.VELOCITY.S;
        dataVelocity.datasets[0].data[idx] = velocity;

        maxVelocity = Math.max(maxVelocity, velocity);
        minVelocity = Math.min(minVelocity, velocity);
      }
    }
    const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
    const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

    if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterLevelSetting);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterLevelSetting);
    } else {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinWaterLevel);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxWaterLevel);
    }

    if (option.minVelocitySetting && option.maxVelocitySetting) {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(option.minVelocitySetting);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxVelocitySetting);
    } else {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinVelocity);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxVelocity);
    }

    setDisabledSwitchButton(false);
  };

  const getHour = async (startDate: Date | null) => {
    setIsYearSelectable(false);
    setIsTimeSelectable(true)
    setIsMonthSelectable(false)
    setDateformat('yyyy-MM-dd HH:mm')
    // validate
    const deviceId = dataDialog?.deviceId;
    if (!deviceId) return;

    // set label
    const labels = Array.from({ length: 60 }, (_, index) => index.toString());
    dataVelocity.labels = labels;
    dataWaterLevel.labels = labels;

    // set start, end day
    const startDay = startDate ? startDate : new Date();
    const endDay = new Date(startDay.getTime());
    startDay.setMinutes(0, 0)
    endDay.setMinutes(59, 59)

    if (!isSameHour(startDay, endDay)) {
      resetGraphData(60);
      return
    }

    setDisabledSwitchButton(true);

    // get records
    const query = {
      query: {
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
          ':timeEnd': { S: endDay.getTime().toString() },
          ':timeStart': { S: startDay.getTime().toString() },
        },
        KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
        TableName: 'DEVICE_RECORD_HOUR',
        ScanIndexForward: false,
      },
    };

    const data = await fpost<any>('api/device/record/query', {
      body: query,
    });
    const items = data[1].Items.reverse();

    resetGraphData(60);

    let maxWaterLevel = 2;
    let maxVelocity = 10;
    let minWaterLevel = 0;
    let minVelocity = 0;

    for (const item of items) {
      const minute = new Date(parseInt(item.CREATE_AT.S)).getUTCMinutes();
      const idx = minute; // Sử dụng trực tiếp minute làm index (0-59)
      if (item.WATER_LEVEL) {
        const waterLevel = item.WATER_LEVEL.S;
        dataWaterLevel.datasets[0].data[idx] = waterLevel;

        maxWaterLevel = Math.max(maxWaterLevel, waterLevel);
        minWaterLevel = Math.min(waterLevel, minWaterLevel);
      }

      if (item.VELOCITY) {
        const velocity = item.VELOCITY.S;
        dataVelocity.datasets[0].data[idx] = velocity;

        maxVelocity = Math.max(maxVelocity, velocity);
        minVelocity = Math.min(minVelocity, velocity);
      }
    }
    const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
    const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

    if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterLevelSetting);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterLevelSetting);
    } else {
      configWaterLevel.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinWaterLevel);
      configWaterLevel.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxWaterLevel);
    }

    if (option.minVelocitySetting && option.maxVelocitySetting) {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(option.minVelocitySetting);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxVelocitySetting);
    } else {
      configVelocity.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinVelocity);
      configVelocity.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxVelocity);
    }

    setDisabledSwitchButton(false);
  }

  const handleReload = async (active: number) => {
    setIsReloading(true);
    setChartLabelString(active)
    switch (active) {
      case 1:
        await getYear(startDate);
        break;
      case 2:
        await getMonth(startDate);
        break;
      case 3:
        await getWeek(startDate);
        break;
      case 4:
        await getDay(startDate);
        break;
      case 5:
        await getHour(startDate);
        break;
      default:
        break;
    }
    setIsReloading(false);
  };

  useEffect(() => {
    const reload = async () => {
      switch (active) {
        case 1:
          await getYear(startDate);
          break;
        case 2:
          await getMonth(startDate);
          break;
        case 3:
          await getWeek(startDate);
          break;
        case 4:
          await getDay(startDate);
          break;
        case 5:
          await getHour(startDate);
          break;
        default:
          break;
      }
    }
    setChartLabelString(active)
    reload()

  }, [
    startDate,
    minVelocitySetting,
    maxVelocitySetting,
    minWaterRateSetting,
    maxWaterRateSetting,
    minWaterLevelSetting,
    maxWaterLevelSetting,
    dataDialog?.deviceId, // Add this to reload when device changes
  ])

  useEffect(() => {
    if (!dataDialog?.deviceId) return;
    const start = async () => {
      setActive(4);
      setChartLabelString(4);
      await getDay(startDate);
    };
    start();
  }, [dataDialog?.deviceId]); // Reload when device changes

  const dispatch = useDispatch();

  if (showPlaceholder) {
    return (
      <div className="absolute top-0 text-center" style={{ width: '600px', height: '200px' }}>
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500">デバイスを選択してください</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="absolute top-0 text-center"
      style={{ width: '600px', height: 'auto'}}
      onMouseMove={(e) => {
        e.stopPropagation();
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
      }}
      onClick={(e) => {
        if (csvLinkRef.current) {
          // Nếu click vào link, không ngăn chặn
          return;
        }
        e.stopPropagation();
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
      }}>
      <div
        id="DialogWaterLevel"
        className="relative m-auto w-full max-w-3xl max-md:h-[100vh] top-0 flex items-center"
      >
        {/* <!-- Modal content --> */}
        <div className="relative rounded-lg bg-white shadow dark:bg-gray-700 w-full">
          {/* <!-- Modal header --> */}
          <p className="font-bold" >{dataDialog.pos}</p>
          <div className="flex flex-wrap items-center justify-between rounded-t border-b p-3 dark:border-gray-600 ">
            <div className="inline  border-2 " style={{ borderColor: '#015CAC' }}>
              <button
                onClick={() => {
                  setActive(1);
                  setChartLabelString(1);
                  getYear(startDate);
                }}
                className={(active == 1 ? 'btn-active' : 'btn') + ' inline px-3 text-center'}
                disabled={disabledSwitchButton}>
                年
              </button>
              <button
                onClick={() => {
                  setActive(2);
                  setChartLabelString(2);
                  getMonth(startDate);
                }}
                className={(active == 2 ? 'btn-active' : 'btn') + ' inline px-3 text-center'}
                disabled={disabledSwitchButton}>
                月
              </button>
              <button
                onClick={() => {
                  setActive(3);
                  setChartLabelString(3);
                  getWeek(startDate);
                }}
                className={(active == 3 ? 'btn-active' : 'btn') + ' inline px-3 text-center'}
                disabled={disabledSwitchButton}>
                週
              </button>
              <button
                onClick={() => {
                  setActive(4);
                  setChartLabelString(4);
                  getDay(startDate);
                }}
                className={(active == 4 ? 'btn-active' : 'btn') + ' inline px-3 text-center'}
                disabled={disabledSwitchButton}>
                日
              </button>
              <button
                onClick={() => {
                  setActive(5);
                  setChartLabelString(5);
                  getHour(startDate);
                }}
                className={(active == 5 ? 'btn-active' : 'btn') + ' inline px-3 text-center'}
                disabled={disabledSwitchButton}>
                時
              </button>
            </div>
            <DatePicker
              className={`rounded-lg ${isRangeInvalid ? 'border-red-500' : 'border-inherit'} md:ml-5 max-md:!mt-5 mt-0 start-date`}
              selected={startDate}
              onChange={(update: any) => {
                handleStartDateChange(update)
              }}
              showTimeSelect={isTimeSelectable}
              showMonthYearPicker={isMonthSelectable}
              showYearPicker={isYearSelectable}
              isClearable={true}
              timeFormat="HH:mm"
              timeIntervals={60}
              dateFormat={dateFormat}
              placeholderText="Select start date"
              showWeekNumbers

            />
            <AiOutlineReload
              className={twMerge(
                'ml-5 cursor-pointer text-[#015CAC] hover:scale-110',
                isReloading ? 'animate-spin' : 'animate-none',
              )}
              onClick={() => {
                handleReload(active);
              }}
              strokeWidth={10}
              title="リセット"
              size={24}
            />
          </div>
          {/* <!-- Modal body --> */}
          <div className=" p-3 border-b dark:border-gray-600">
            {/*water level*/}
            <div className="flex items-center space-x-4 mt-2">
              <label htmlFor="minFlow" className="font-medium text-sm whitespace-nowrap">水位</label>
              <div className="flex items-center space-x-2">
                <input
                    type="number"
                    id="minFlow"
                    placeholder="Min"
                    className="rounded border p-1 w-20 text-sm"
                    value={minWaterLevelSetting ?? ''}
                    onChange={(e) => handleMinMax(e, 'minWaterLevelSetting')}
                />
                <span className="text-gray-500">-</span>
                <input
                    type="number"
                    id="maxFlow"
                    placeholder="Max"
                    className="rounded border p-1 w-20 text-sm"
                    value={maxWaterLevelSetting ?? ''}
                    onChange={(e) => handleMinMax(e, 'maxWaterLevelSetting')}
                />
              </div>
            </div>
            {/* velocity */}
            <div className="flex items-center space-x-4 mt-2 mb-2">
              <label htmlFor="minFlow" className="font-medium text-sm whitespace-nowrap">流速</label>
              <div className="flex items-center space-x-2">
                <input
                    type="number"
                    id="minFlow"
                    placeholder="Min"
                    className="rounded border p-1 w-20 text-sm"
                    value={minVelocitySetting ?? ''}
                    onChange={(e) => handleMinMax(e, 'minVelocitySetting')}
                />
                <span className="text-gray-500">-</span>
                <input
                    type="number"
                    id="maxFlow"
                    placeholder="Max"
                    className="rounded border p-1 w-20 text-sm"
                    value={maxVelocitySetting ?? ''}
                    onChange={(e) => handleMinMax(e, 'maxVelocitySetting')}
                />
              </div>
            </div>
            {/* {isWaterLevel && !isFlowRate ? <Line data={dataWater} options={configWater.options} /> : ''}
            {isFlowRate && !isWaterLevel ? <Line data={dataFlowRate} options={configFlowRate.options} /> : ''}
            {(isFlowRate && isWaterLevel) || !isMap ? <Line data={dataDouble} options={configDouble.options} /> : ''} */}
            <div style={{ height: '250px' }}>
              <Line redraw={true} data={dataWaterLevel} options={configWaterLevel.options} />
            </div>
            <div style={{ height: '250px' }}>
              <Line redraw={true} data={dataVelocity} options={configVelocity.options} />
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}
